module.exports = __webpack_public_path__ + "static/media/(000001).93e3ddb7.jpg";